import React from 'react';
import { CardElement } from 'react-stripe-elements';

import { theme } from 'kb-shared';

// Have to use this as Stripe Elements are in an iFrame
// and won't inherit CSS
const stripeElementStyle = {
  base: {
    fontSize: '24px',
    fontFamily: 'FoundersGroteskText',
    fontDisplay: 'swap',
    fontWeight: 100,
    '::placeholder': {
      color: theme.colors.gray
    }
  }
};

const CreditCardEntry = () => {
  return <CardElement style={stripeElementStyle} />;
};

export default CreditCardEntry;
